/**
 * Dummy operation data for MissionCalendarPage (Phase 1)
 * Replace with real API calls in Phase 2.
 * Source: real API payload — duration normalised to Number.
 */

export const dummyOperations = [];

/**
 * Get primary status label for an operation
 */
export const getPrimaryStatus = (operation) => {
    if (!operation.authorizations || operation.authorizations.length === 0) {
        return 'No Authorization';
    }
    return operation.authorizations[0].status;
};

/**
 * Map status to a Schedule-X calendar ID (for color coding)
 */
export const statusToCalendarId = (status) => {
    switch (status) {
        case 'Authorized': return 'authorized';
        case 'Pending': return 'pending';
        case 'Complete': return 'complete';
        case 'De-authorized': return 'deauthorized';
        case 'Deleted': return 'deleted';
        case 'Rescinded Awaiting': return 'rescinded';
        case 'Never Authorized': return 'never';
        case 'Invalid Detected': return 'invalid';
        case 'No Authorization': return 'noauth';
        case 'Note': return 'note';
        default: return 'pending';
    }
};
